import React from "react";

const CoachingTile = props => {
    try {
        return <div className="card coaching-tile">
            <div className="card-header">
                <div className="row">
                    <div className="col-12">
                        <div className="card-heading d-flex">
                            <img className="coaching-image"
                                src="images/coaching-icon.svg"
                                alt="coaching icon" />
                            <div className="coaching-heading">WELLNESS COACHING</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-12">
                        <>
                            <ul className="angle-bullets">
                                <li> Available to You and Your Spouse</li>
                                <li>Meet with a Wellness Coach</li>
                                <li>Improve Your Well-being</li>
                            </ul>
                        </>

                    </div>
                    <div className="col-12 coaching-tile__schedule">
                        <a href="https://outlook.office365.com/owa/calendar/ThriveWellnessCoaching@swmail.onmicrosoft.com/bookings/" onClick={() => logUI("MBHWeb.UI.WellnessGoals.CoachingTile.ThriveWellnessCoaching", new Date(), Tools.getURLPath())}
                            className="card-link" target="_blank">BOOK A SESSION</a>
                           
                    </div>
                </div>
            </div>
        </div>;
    } catch (ex) {
        console.error(ex);
    }
}

export default CoachingTile;